var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video (3) 1",
    clipPath: "url(#clip0_0_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    d: "M11.2083 3.09235C11.3611 2.98327 11.5621 2.96814 11.729 3.05385C11.896 3.1398 12.001 3.31217 12.001 3.5V8.49972C12.001 8.68755 11.896 8.85992 11.729 8.94587C11.562 9.03165 11.3611 9.01731 11.2083 8.9082L7.70862 6.40792C7.57693 6.31385 7.49861 6.16211 7.49852 6.00028C7.49852 5.83834 7.57685 5.68592 7.70862 5.5918L11.2083 3.09235ZM8.86208 5.99944L10.9982 7.52455V4.47433L8.86208 5.99944Z",
    fill: "#71500C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    d: "M7.49852 3.50028C7.49852 3.22493 7.27499 3.0014 6.99964 3.0014H1.5002C1.22484 3.0014 1.00131 3.22493 1.00131 3.50028V8.5C1.00131 8.77535 1.22484 8.99888 1.5002 8.99888H6.99964C7.27499 8.99888 7.49852 8.77535 7.49852 8.5V3.50028ZM8.50131 8.5C8.50131 9.32922 7.82886 10.0017 6.99964 10.0017H1.5002C0.670981 10.0017 -0.0014767 9.32922 -0.0014767 8.5V3.50028C-0.0014767 2.67106 0.670981 1.99861 1.5002 1.99861H6.99964C7.82886 1.99861 8.50131 2.67106 8.50131 3.50028V8.5Z",
    fill: "#71500C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5f966a8e20b52ebd4316f5fbcf926801.svg";
export { ForwardRef as ReactComponent };